import * as React from "react";
import { Box, FormControlLabel, Checkbox } from "@mui/material";
import { getRentDueReport, unitVacantReport } from "state/apis";
import "./index.css";
import { Grid } from "@mui/material";
import moment from "moment";
import DefaultProperty from "components/DefaultProperty";
import { useSelector } from "react-redux";
import GetAppIcon from "@mui/icons-material/GetApp";
import Button from "@mui/material/Button";
import jsPDF from "jspdf";
import html2canvas from "html2canvas";
import { formatAmount } from "utils/constants";

const UnitVacantReport = () => {
    const propertyName = useSelector((state) => state.global.propertyName);
    const property = useSelector((state) => state.global.defaultProperty);
    const [isLoading, setIsLoading] = React.useState(false);
    const [data, setData] = React.useState({});
    const [openDefaultProperty, setOpenDefaultProperty] = React.useState(false);

    React.useEffect(() => {
        setIsLoading(true);
        if (!property) {
            setOpenDefaultProperty(true);
        }
        fetchData(false);
        setIsLoading(false);
    }, []);

    const fetchData = async (data) => {
        try {
            const res = await unitVacantReport({ allProperty: data });
            setData(res.data);
            setIsLoading(false);
        } catch (error) {
            console.error("Error fetching data:", error);
            setIsLoading(false);
        }
    };

    const handleCloseDefaultProperty = () => {
        setOpenDefaultProperty(false);
    };
    const handleAllProperty = (e) => {
        let value = e.target.checked;
        if (value) {
            fetchData(true);
        } else {
            fetchData(false);
        }
    };

    const reportRef = React.useRef();

    const handlePrint = () => {
        const input = reportRef.current;

        html2canvas(input, { scale: 2 }).then((canvas) => {
            const imgData = canvas.toDataURL("image/png");
            const pdf = new jsPDF("p", "mm", "a4");

            const pdfWidth = pdf.internal.pageSize.getWidth();
            const pdfHeight = pdf.internal.pageSize.getHeight();

            const margin = 10; // Add margin (padding)

            // Get the image height and scale it proportionally
            const imgProps = pdf.getImageProperties(imgData);
            const imgHeight = (imgProps.height * (pdfWidth - 2 * margin)) / imgProps.width;

            let heightLeft = imgHeight;
            let position = margin;

            pdf.addImage(imgData, "PNG", margin, position, pdfWidth - 2 * margin, imgHeight);
            heightLeft -= pdfHeight - 2 * margin;

            while (heightLeft > 0) {
                position = heightLeft - imgHeight + margin;
                pdf.addPage();
                pdf.addImage(imgData, "PNG", margin, position, pdfWidth - 2 * margin, imgHeight);
                heightLeft -= pdfHeight - 2 * margin;
            }

            pdf.save(`unit-vacant-report.pdf`);
        });
    };

    return (
        <Box m="1.5rem 2.5rem" mb={5}>
            <Box display="flex" justifyContent="flex-end" pt={0} paddingLeft={0}>
                <Grid container spacing={1} p={"5px"} alignItems="center">
                    <Grid item xs={4}>
                        <Grid item xs={6}>
                            <FormControlLabel
                                control={
                                    <Checkbox
                                        checked={data.vacant}
                                        onChange={(e) => handleAllProperty(e)}
                                        name="vacant"
                                        color="primary"
                                    />
                                }
                                label="All properties"
                            />
                        </Grid>
                    </Grid>
                    <Grid item xs></Grid>
                    <Grid item xs="auto">
                        <button className="download-btn" onClick={handlePrint}>
                            Download PDF
                        </button>
                    </Grid>
                </Grid>
            </Box>
            {!property && (
                <DefaultProperty
                    open={openDefaultProperty}
                    onClose={() => handleCloseDefaultProperty}
                />
            )}

            <div className="report-container">
                <div ref={reportRef}>
                    <table border="1" cellPadding="5" cellSpacing="0">
                        <thead>
                            <tr>
                                <th colSpan={5} style={{ textAlign: "center" }}>
                                    UNIT VACANT REPORT
                                </th>
                            </tr>
                            <tr>
                                <th style={{ textAlign: "center" }}>PROPERTY</th>
                                <th style={{ textAlign: "center" }}>UNIT</th>
                                <th style={{ textAlign: "center" }}>VACANT DATE</th>
                                <th style={{ textAlign: "center" }}>LAST CONTRACT RENT</th>
                                <th style={{ textAlign: "center" }}>VACANT PERIOD</th>
                            </tr>
                        </thead>

                        <tbody>
                            {data && data.length ? (
                                <>
                                    {data.map((val, index) => (
                                        <tr key={index}>
                                            <td>{val.propertyName}</td>
                                            <td>{val.unitNumber}</td>
                                            <td style={{ textAlign: "center" }}>
                                                {val?.terminatedDate
                                                    ? moment(val?.terminatedDate).format(
                                                          "DD/MM/YYYY"
                                                      )
                                                    : "-"}
                                            </td>
                                            <td style={{ textAlign: "right" }}>
                                                {val?.yearRent
                                                    ? `${formatAmount(val.yearRent)}`
                                                    : "-"}
                                            </td>
                                            <td>{val.vacantPeriod ? val.vacantPeriod : ""}</td>
                                        </tr>
                                    ))}
                                </>
                            ) : (
                                <tr>
                                    <td colSpan="5" style={{ textAlign: "center" }}>
                                        No data found
                                    </td>
                                </tr>
                            )}

                            <tr>
                                <td colSpan={5}></td>
                            </tr>
                        </tbody>
                    </table>
                </div>
            </div>
        </Box>
    );
};

export default UnitVacantReport;
